<template>
  <div class="container-fluid max-container">
    <div class="row">
      <Header />
      <PageLoader v-if="loadingStatus === 'loading'" class="py-12" />
      <section class="recent-ancetry-wrapper" v-else-if="loadingStatus === 'loaded'">
        <div class="container">
          <div class="row">
            <FatherLineNavigation />
            <router-view />
          </div>
        </div>
      </section>
      <section class="recent-ancetry-wrapper" v-else-if="loadingStatus === 'failed'">
        <div class="container">
          <div class="row">
            <ParentalPageError type="ydna" />
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script setup>
import Header from "@/components/header/Header.vue";
import FatherLineNavigation from "@/view/ancestry/fatherline/FatherLineNavigation.vue";
import { useFatherlineStore } from "@/store/parentalStore";
import { useLoading } from "@/composables/useLoading";
import ParentalPageError from "@/view/ancestry/ParentalPageError.vue";
import { watch } from "vue";
import store from "@/store";

const fatherlineStore = useFatherlineStore();
const { loadingStatus, finishLoading, failLoading } = useLoading();

watch(() => store.getters.profile,
  () => {
    fatherlineStore
      .getResult().then(() => {
        if (fatherlineStore.result && Object.keys(fatherlineStore.result).length === 0) {
          throw new Error("No result");
        }
      })
      .then(finishLoading)
      .catch((e) => {
        console.error(e);
        failLoading();
      });
  }, { immediate: true });
</script>
